import axios from 'axios'
import { timeoutRetryRejectionInterceptor } from './interceptors'

const axiosVerbose = axios.create({
  timeout: 10000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})

axiosVerbose.interceptors.response.use(
  undefined,
  timeoutRetryRejectionInterceptor
)

export default axiosVerbose
